// List of route grades

const grades = [
  'grade1',
  'grade2',
  'grade3',
  'grade4',
  'grade5'
]

export default grades
